const expenseStatusesConstants = Object.freeze({
  TO_APPROVE: 0,
  APPROVED: 1,
  AWAITING_PAYMENT: 2,
  PAID: 3,
  DRAFT: 4,
  REJECTED: 5,
  TRANSACTION_AUTHORIZED: 6,
  TRANSACTION_REJECTED: 7,
  TRANSACTION_REFUND: 8,
  TRANSACTION_REVERSED: 9
});

const expenseTypesConstants = Object.freeze({
  INVOICE: 0,
  RECEIPT: 1,
  NO_RECEIPT: 2
});

const expenseInvoicesStatusConstants = Object.freeze({
  CONFIRMED: 'CONFIRMED',
  MATCHED: 'MATCHED',
  PENDING: 'PENDING',
});

const expensePaymentMethodConstants = Object.freeze({
  CASH: 0,
  CARD: 1,
  WIRE: 2,
  REIMBURSEMENT: 3
});

const expensePolicyStatusConstants = Object.freeze({
  OUT_OF_POLICY: 'out_of_policy',
  MISSING_INFO: 'missing_info',
});

const expenseReviewStatusConstants = Object.freeze({
  DRAFT: 'draft',
  IN_REVIEW: 'in_review',
  APPROVED: 'approved',
  REJECTED: 'rejected'
});

const expensesPlanConstants = Object.freeze({
  ADVANCED: 'advanced',
  BASIC: 'basic',
});

export {
  expenseStatusesConstants,
  expenseTypesConstants,
  expenseInvoicesStatusConstants,
  expensePaymentMethodConstants,
  expensePolicyStatusConstants,
  expenseReviewStatusConstants,
  expensesPlanConstants
};

